import React from "react";

function TabelLaporanKeuangan() {
    return (
        <div className="laporan-keuangan-container">
            <div className="data-table border-right">
                <h5>Laporan Posisi Keuangan Tahun 2025</h5>
                <br/>
                <div className="table-ojk">
                    <table>
                        <tbody>
                        <tr className="border-none">
                            <th colSpan="2"><strong>Aset</strong></th>
                        </tr>
                        <tr>
                            <td className="title !pb-0">Aset Lancar</td>
                            <td className="value !pb-0"> 13.867.493.663</td>
                        </tr>
                        <tr className="border-bottom">
                            <td className="title">Aset Tidak Lancar</td>
                            <td className="value">3.612.550.399</td>
                        </tr>
                        <tr className="border-bottom">
                            <td className="title"><strong>Total Aset</strong></td>
                            <td className="value"><strong>17.480.044.062</strong></td>
                        </tr>

                        <tr className="border-none">
                            <td colSpan="2" className="!p-5"/>
                        </tr>

                        <tr className="border-none">
                            <th colSpan="2"><strong>Kewajiban</strong></th>
                        </tr>
                        <tr>
                            <td className="title !pb-0">Kewajiban Lancar</td>
                            <td className="value !pb-0">598.194.001</td>
                        </tr>
                        <tr className="border-bottom">
                            <td className="title">Kewajiban Tidak Lancar</td>
                            <td className="value">699.804.635</td>
                        </tr>
                        <tr className="border-bottom">
                            <td className="title"><strong>Total Kewajiban</strong></td>
                            <td className="value"><strong>1.297.998.636</strong></td>
                        </tr>
                        <tr className="border-none">
                            <td colSpan="2"/>
                        </tr>
                        <tr className="border-none">
                            <th className="title"><strong>Ekuitas</strong></th>
                            <td className="value"><strong>16.182.045.426</strong></td>
                        </tr>

                        <tr className="border-none">
                            <td colSpan="2" style={{paddingTop: '30px'}}></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="data-table">
                <h5 className="pr-4">Laporan Laba Rugi Komprehensif Tahun 2025</h5>
                <br/>
                <div className="table-ojk">
                    <table>
                        <tbody>
                        <tr className="border-none">
                            <th colSpan="2" style={{padding: '12px'}}/>
                        </tr>
                        <tr>
                            <td className="title !pb-0">Pendapatan</td>
                            <td className="value !pb-0">12.236.508.201</td>
                        </tr>
                        <tr className="border-bottom">
                            <td className="title">Beban Operasional</td>
                            <td className="value">16.825.503.731</td>
                        </tr>
                        <tr className="border-bottom">
                            <td className="title"><strong>Laba Komprehensif</strong></td>
                            <td className="value"><strong>(4.588.995.530)</strong></td>
                        </tr>
                        <tr className="border-none">
                            <td colSpan="2" style={{paddingTop: '40px'}}></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="data-table">
                <h5>Opini Audit 2025</h5>
                <div className="table-ojk">
                    <table>
                        <tbody>
                        <tr className="border-none">
                            <td colSpan="2" style={{paddingLeft:"0", color:"#707070"}}>Wajar tanpa pengecualian</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default TabelLaporanKeuangan;